import { type FC } from 'react';
import cn from 'classnames';

import { productOfDayRewardsConfig } from '@/common/config/product-of-day-config';
import { type TicketRewardType } from '@/common/types/lottery';
import { H2, StringXSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import styles from './styles.module.scss';

interface RewardDisplayProps {
  value: number;
  type: TicketRewardType | 'tgem' | 'usdt' | 'dice';
}

const ProductOfDaySpinReward: FC<RewardDisplayProps> = ({ value, type }) => {
  const config =
    productOfDayRewardsConfig[type as keyof typeof productOfDayRewardsConfig];
  const isUsdt = type === 'usdt';

  const grayBgList = ['dice', 'silverTicket'];

  return (
    <div
      className={cn(
        'flex flex-col-reverse items-center gap-1 rounded-2xl relative overflow-hidden size-[160px] pb-[1.375rem]',
        {
          [styles.green]: type === 'usdt',
          [styles.purple]: type === 'tgem',
          [styles.gray]: grayBgList.includes(type),
          [styles.gold]: type === 'goldTicket',
          [styles.blue]: type === 'diamondTicket',
        },
      )}
    >
      <StringXSmall className="!text-white/60">{config?.label}</StringXSmall>
      <H2 weight="extrabold">
        {isUsdt && '$'}
        {value}
      </H2>

      <Picture
        img={config?.icon.png}
        webp={config?.icon.webp}
        className="w-1/2"
        alt={type}
      />

      <div className={styles.ellipse} />
    </div>
  );
};

export default ProductOfDaySpinReward;
